import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.css';

const NavigateLink = (props) => {
  const { text, linkText, linkUrl } = props;
  let navigate = useNavigate();
  const navigationHandler = (e) => {
    e.preventDefault();
    navigate(linkUrl, { replace: true });
  };
  return (
    <>
      <span className={styles.link_text}>{text}</span>
      <a href="javascript.void(0)" onClick={navigationHandler}>
        <span className={styles.linktext_color}>{linkText}</span>
      </a>
    </>
  );
};

export default memo(NavigateLink);
